import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VerifyEmailService } from '../services/verify-email.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-email-verify',
  templateUrl: './email-verify.component.html',
  styleUrls: ['./email-verify.component.scss'],
})
export class EmailVerifyComponent implements OnInit {
  verifying = true;
  success = false;
  message = '';

  constructor(
    private route: ActivatedRoute,
    private verifyEmailService: VerifyEmailService,
    private router: Router,
    private messageService: NzMessageService
  ) {}

  ngOnInit(): void {
    const token = this.route.snapshot.paramMap.get('token');
    if (token) {
      this.verifyToken(token);
    } else {
      this.verifying = false;
      this.message = 'Invalid verification link';
      this.goToLogin();
    }
  }

  async verifyToken(token: string): Promise<void> {
    try {
      await this.verifyEmailService.verifyEmail(token);
      this.success = true;
      this.message = 'Your email has been verified successfully';
    } catch (error: any) {
      this.success = false;
      this.message = error.error?.message || 'Verification failed';
    } finally {
      this.verifying = false;
    }
  }

  goToLogin(): void {
    this.router.navigate(['/']);
  }
}
